import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { DatePipe } from '@angular/common';
import { AppService } from './app.service';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable()
export class StreamingService {
  account:any;
  basePath:string;

  apiUrl:any;
  api:any;

  constructor(private http: HttpClient,
    public datepipe: DatePipe,
    private router:Router,
    private appService:AppService,
    //private authService: AuthService
  ) { 
    this.apiUrl = appService.getApiUrl();
    this.api = appService.getApi();
    
  }

  getTimeStamp(){
    //return firebase.firestore.FieldValue.serverTimestamp();
  }

  

  isOnline(screen_id,current_ad_id,transmiting,webcam,position):Observable<ApiData>{
    let mid = this.appService.getMachineId();
    let client_version = this.appService.getVersion();
    if(this.appService.isConnected(screen_id)){    
      let d = new Date();
      let local_timestamp = d.getTime()/1000;
      let connect_data = this.appService.getConnectData(screen_id);
      let response:any;
      let user_agent = 'N/A';
      let platform = 'N/A';
      if (navigator.userAgent) {
        user_agent = navigator.userAgent;
      }

      if (navigator.platform) {
        platform = navigator.platform;
      }
      let language = 'N/A';
      if(navigator.language){
        language = navigator.language;
      }
      let body = {
        token:connect_data.token,
        screen_id:connect_data.screen_id,
        session_id:mid,
        current_ad:current_ad_id,
        transmiting:transmiting,
        webcam:webcam,
        latitude:position.latitude,
        longitude:position.longitude,
        client_version:client_version,
        client_agent:user_agent,
        client_platform:platform,
        client_language:language,
        local_timestamp:local_timestamp
      }
      
      return this.http.post<ApiData>(this.apiUrl+this.api.online,body);
      
    }else{
      return new Observable((data)=>{
        return null;
      })
    }
  }

  isOffline(screen_id){
     //this.db.doc('/screens/'+screen_id).update({session_id:null});
  }


  countAdView(account_key,ad_key,screen_id,screen_name,lat,long,ad_name,ad_src,ad_duration):boolean{
    this.addAdCountQueue(screen_id,screen_name,account_key,ad_key,lat,long,ad_name,ad_src,ad_duration);
    let mid = this.appService.getMachineId();
    return true;
    
  }

  processAdCountQueue(screen_id){
    //console.log("PROCEQUEUE:"+screen_id);
    let ads_to_count = this.getAdCountQueue(screen_id);
    if(this.appService.isConnected(screen_id) && ads_to_count.length > 0){    
      console.log("CALL:");
      let mid = this.appService.getMachineId();
      let connect_data = this.appService.getConnectData(screen_id);
      
      let body = {
        token:connect_data.token,
        screen_id:connect_data.screen_id,
        session_id:mid,
        queue:ads_to_count
      }
      this.http.post(this.apiUrl+this.api.countview,body).subscribe(()=>{
        this.cleanAdCountQueue(screen_id);  
        console.log("CLEAN AD QUEUE");
      });
      
      return true;
      
    }else{
      return false;
    }
  }

  getAdCountQueue(screen_id){
    let mid = this.appService.getMachineId();
    let json = window.localStorage.getItem(mid+'-AdCountQueue-'+screen_id);
    
    if(!json || json == '' || json == null || json == '' ){
      json = "[]";
    }
    let data = JSON.parse(json);
    
    return data;
  }

  getDateSrt(){
    var date = new Date();
    return this.datepipe.transform(date,"yyyy-MM-dd-HH"); //output : 2018-02-13
  }

  addAdCountQueue(screen_id,screen_name,account_id,ad_id,latitude,longitude,ad_name,ad_src,ad_duration){
    let mid = this.appService.getMachineId();
    //console.log("ad count");
    let machine_name = this.appService.getName();
    let json = window.localStorage.getItem(mid+'-AdCountQueue-'+screen_id);
    let d = new Date();
    let time_stamp = d.getTime()/1000;
    let date_str = this.getDateSrt();
    
    //let date_str = d.getFullYear()+'-'+('0' + d.getMonth()).slice(-2)+'-'+('0' + d.getDay()).slice(-2)+'-'+('0' + d.getHours()).slice(-2);
    if(!json || json == '' || json == null || json == '' ){
      json = "[]";
    }
    let data = JSON.parse(json);
    let ffind=false;
    data.forEach((element,i) => {
      if(element.key == account_id+'-'+ad_id+'-'+date_str){
        ffind = true;
        data[i].views += 1;
      }
    });
    if(ffind == false){
      data.push({
        key:account_id+'-'+ad_id+'-'+date_str,
        screen_id:screen_id,
        account_id:account_id,
        ad_id:ad_id,
        views:1,
        date_index:date_str,
        client_id:mid,
        screen_name:screen_name,
        latitude:latitude,
        longitude:longitude,
        client_name:machine_name,
        ad_name:ad_name,
        ad_src:ad_src,
        ad_duration:ad_duration,
        time_stamp:time_stamp
      })
    }
    window.localStorage.setItem(mid+'-AdCountQueue-'+screen_id,JSON.stringify(data));
    return data;
  }

  cleanAdCountQueue(screen_id){
    let mid = this.appService.getMachineId();
    
    window.localStorage.setItem(mid+'-AdCountQueue-'+screen_id,'[]');
  }

  updateScreenshot(account_key,key,url){

    //let d = new Date().getTime()/1000;
    //let d = firebase.firestore.FieldValue.serverTimestamp();
    //this.db.doc('/screens/'+key).update({ screenshot_url:url, screenshot_last_time: d});
  }

  checkAuditable(screen_id,current_ad){
    let mid = this.appService.getMachineId();
    let json = localStorage.getItem(mid+'-Audit-'+screen_id);
    if(!json || json == '' || json == null || json == '' || json == 'null'){
      json = "[]";
    }
    let data = JSON.parse(json);
    let d = new Date();
    let date_str = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDay()+'-'+d.getHours();
    let fcheck = false;
    let ffind = false;
    data.forEach((a,ind)=>{
      if(a.id == current_ad.ad.id){
        ffind = true;
        if(a.date != date_str){
          fcheck = true;
          data[ind].date = date_str;
        }
      }
    })
    if(!ffind){
      data.push({id:current_ad.ad.id,date:date_str});
      fcheck = true;
    }
    localStorage.setItem(mid+'-Audit-'+screen_id,JSON.stringify(data));
    return fcheck;
  }

  getScreen(screen_id):Observable<ApiData>{
    let mid = this.appService.getMachineId();
    if(this.appService.isConnected(screen_id)){    
  
      let connect_data = this.appService.getConnectData(screen_id);
      let response:any;

      let params = new HttpParams();
      params = params.append('token',connect_data.token);
      params = params.append('screen_id', connect_data.screen_id);
      params = params.append('session_id',mid);

      let call = this.http.get<ApiData>(this.apiUrl+this.api.get,{params: params});
      return call;
    }
  }

  getStreaming(screen_id):Observable<ApiData>{
    let mid = this.appService.getMachineId();
    if(this.appService.isConnected(screen_id)){    
  
      let connect_data = this.appService.getConnectData(screen_id);
      let response:any;

      let params = new HttpParams();
      params = params.append('token',connect_data.token);
      params = params.append('screen_id', connect_data.screen_id);
      params = params.append('session_id',mid);

      let call = this.http.get<ApiData>(this.apiUrl+this.api.streaming,{params: params});
      return call;
    }
  }

}
export interface ApiData{
  data:any
  status:any,
  message:any,
  v:any,
}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/services/streaming.service.ts